(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tierloft-flipbook"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tierloft-flipbook')) {
  customElements.define('tierloft-flipbook', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-book-config]').textContent);
      this.pages = this.config.pages;
      this.index = 0;
      this.wide = window.matchMedia('(min-width: 761px)');
      this.spread = this.querySelector('[data-book-spread]');
      this.viewport = this.querySelector('[data-book-viewport]');
      this.pageInput = this.querySelector('[data-book-page]');
      this.status = this.querySelector('[data-book-status]');
      this.prev = this.querySelector('[data-book-prev]');
      this.next = this.querySelector('[data-book-next]');
      this.prev.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.pageInput.addEventListener('change', () => this.show(Number(this.pageInput.value) - 1));
      this.querySelector('[data-book-zoom]').addEventListener('click', (event) => {
        const active = this.viewport.dataset.zoom !== 'true';
        this.viewport.dataset.zoom = String(active);
        event.currentTarget.setAttribute('aria-pressed', String(active));
      });
      this.viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      this.viewport.addEventListener('touchstart', (event) => {
        this.touchStart = event.touches.length === 1 ? [event.touches[0].clientX,event.touches[0].clientY] : null;
      }, {passive:true});
      this.viewport.addEventListener('touchend', (event) => {
        if (!this.touchStart || this.viewport.dataset.zoom === 'true') return;
        const dx = event.changedTouches[0].clientX - this.touchStart[0];
        const dy = event.changedTouches[0].clientY - this.touchStart[1];
        if (Math.abs(dx) > 65 && Math.abs(dx) > Math.abs(dy)*1.5) this.move(dx < 0 ? 1 : -1);
        this.touchStart = null;
      }, {passive:true});
      this.onResize = () => this.show(this.index);
      this.wide.addEventListener('change', this.onResize);
      this.show(0);
      const order = document.querySelector('tierloft-lookbook');
      if (order) order.id = 'tierloft-order';
      if (new URLSearchParams(location.search).get('rasse')) {
        customElements.whenDefined('tierloft-lookbook').then(() => requestAnimationFrame(() => order?.scrollIntoView({block:'start'})));
      }
    }
    disconnectedCallback() { this.wide?.removeEventListener('change', this.onResize); }
    visibleIndices() { return this.wide.matches && this.index > 0 && this.index < this.pages.length-1 ? [this.index,this.index+1] : [this.index]; }
    move(direction) {
      const step = this.wide.matches ? (direction > 0 ? this.visibleIndices().length : (this.index > 1 ? 2 : 1)) : 1;
      this.show(this.index + direction*step);
    }
    show(index) {
      if (!Number.isFinite(index)) index = 0;
      this.index = Math.max(0,Math.min(this.pages.length-1,Math.floor(index)));
      if (this.wide.matches && this.index > 0 && this.index < this.pages.length-1 && this.index%2 === 0) this.index -= 1;
      const visible = this.visibleIndices();
      this.spread.replaceChildren(...visible.map(i => this.leaf(this.pages[i])));
      this.pageInput.value = this.index+1;
      this.prev.disabled = this.index === 0;
      this.next.disabled = visible.at(-1) === this.pages.length-1;
      this.status.textContent = `${this.config.copy.page} ${visible.map(i=>i+1).join('–')} / ${this.pages.length}`;
      this.viewport.scrollLeft = 0;
      const ahead = this.pages[visible.at(-1)+1];
      if (ahead) { const image = new Image(); image.src = ahead.url; }
    }
    leaf(page) {
      const leaf = document.createElement('div'); leaf.className = 'tl-book__leaf';
      const image = document.createElement('img'); image.src = page.url;
      image.width = page.width; image.height = page.height;
      image.alt = `${this.config.copy.page} ${page.page}`;
      image.addEventListener('error', () => { this.status.textContent = this.config.copy.error; });
      leaf.append(image);
      page.links.forEach(link => {
        const anchor = document.createElement('a'); anchor.className = 'tl-book__hotspot';
        anchor.href = link.url;
        const slug = new URL(link.url).searchParams.get('rasse') || '';
        anchor.setAttribute('aria-label', `${this.config.copy.select}: ${slug.replaceAll('-',' ')}`);
        Object.assign(anchor.style,{left:`${link.x}%`,top:`${link.y}%`,width:`${link.w}%`,height:`${link.h}%`});
        anchor.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const order = document.querySelector('tierloft-lookbook');
          if (!order) return;
          event.preventDefault();
          const url = new URL(location.href); url.searchParams.set('rasse',slug); url.hash = 'tierloft-order';
          history.pushState({tierloftBreed:slug},'',url);
          window.dispatchEvent(new PopStateEvent('popstate'));
          order.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
        });
        leaf.append(anchor);
      });
      return leaf;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tierloft-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('tierloft:cart:updated', (event) => {
    if (!Number.isInteger(event.detail?.item_count)) return;
    document.querySelectorAll('.tlh-cart b').forEach((badge) => {
      badge.textContent = String(event.detail.item_count);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
